import { forwardRef } from "react";

/*
 * Same header swoosh as Business/PDF/MP3 (viewBox 375×526, path to H375).
 * The previous 341×478 path stopped at H340.779 and used meet, which left a
 * 1px body-colored gap on the right even with .qr-backdrop at 109% width.
 * preserveAspectRatio="none" + display:block stretch the fill to the SVG
 * edges without changing the wave or primaryColor. Height still follows
 * useAdjustBackdropHeight so the curve sits behind the hero card.
 */
const EventBackdrop = forwardRef(({ color }, backdropRef) => (
  <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 overflow-x-clip">
    <div
      ref={backdropRef}
      className="qr-backdrop"
      style={{ "--bg-color": color || "#00296B" }}
      id="color_palette"
    >
      <svg
        width="375"
        height="526"
        viewBox="0 0 375 526"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="block h-auto w-full"
        preserveAspectRatio="none"
      >
        <path
          d="M0 0H375V506C375 506 293.5 461 187.5 506C81.5 551 0 506 0 506V0Z"
          fill="var(--bg-color)"
          className="transition-colors duration-500"
        />
      </svg>
    </div>
  </div>
));

EventBackdrop.displayName = "EventBackdrop";

export default EventBackdrop;
